import { LANDING_NAV_ITEMS, SOCIAL_ICONS } from "@/utils/constants";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import monietab from "/public/monietab-white.svg";

const Footer = () => {
  return (
    <div>
      <div className="lg:px-20 md:px-12 px-6">
        <section className="flex md:flex-row flex-col justify-between items-center  text-[#ffffff] bg-[#873C97] lg:translate-y-1/3 translate-y-[20%] rounded-[20px]  p-6">
          <div className="space-y-4 md:w-[50%] w-full">
            <h2 className="font-bold text-3xl leading-[48px]">
              Join Monietab Community
            </h2>
            <p className="text-sm">
              Connect with like-minded individuals on our WhatsApp platform,
              where you&apos;ll find support and guidance for your financial
              journey. Gain access to valuable tips, expert advice, and learning
              opportunities. it&apos;s completely free and open to everyone!
            </p>
            <div className="bg-[#ffffff] font-semibold px-4 py-2 rounded-[5px] w-fit">
              <Link
                className="text-primary"
                href="https://chat.whatsapp.com/Be2OkZNYDCgLbY9gkzw4P4"
              >
                Join Community
              </Link>
            </div>
          </div>
          <Image
            src="/connect.svg"
            alt="icon"
            width={370}
            height={255}
            className="mt-4 rounded-[5px]"
          />
        </section>
      </div>
      <main className="bg-secondary w-full lg:px-20 md:px-12 px-6 pt-40 text-[#ffffff]">
        {/* Footer Content */}
        <div>
          <div className="flex md:flex-row space-y-6 md:space-y-0 flex-col text-[#ffffff] w-full justify-between">
            <section>
              <div>
                <div className="flex items-center mb-2 md:text-3xl text-xl">
                  <span className="text-[#ffffff] font-semibold">Monie</span>
                  <span>tab</span>
                </div>
                <div className="flex gap-2 md:gap-3 items-center">
                  {SOCIAL_ICONS.map(({ icon, href }, index) => (
                    <Link key={index} href={href} target="_blank">
                      {icon}
                    </Link>
                  ))}
                </div>
              </div>
            </section>

            <section className="flex space-y-6 md:space-y-0 md:flex-row flex-col justify-between md:w-[50%] w-[80%]">
              <div className="flex justify-between lg:gap-16 md:gap-8">
                <div className="text-base md:space-y-4 space-y-2 font-bold">
                  {LANDING_NAV_ITEMS.slice(0, 2).map(
                    ({ title, href }, index) => {
                      return (
                        <div key={index}>
                          <Link href={href}>{title}</Link>
                        </div>
                      );
                    }
                  )}
                </div>

                <div className="space-y-2">
                  <h2 className="text-base font-bold">Legal</h2>
                  <div>
                    {LANDING_NAV_ITEMS.slice(5, 8).map(
                      ({ title, href }, index) => {
                        return (
                          <div key={index}>
                            <Link href={href} className="text-sm">
                              {title}
                            </Link>
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>
              </div>
              <div className="space-y-2 md:w-[50%] justify-start md:hidden">
                <h2 className="text-base font-bold">Resources</h2>
                <div>
                  <Link href="/" className="text-sm">
                    Calculator
                  </Link>
                  {LANDING_NAV_ITEMS.slice(2, 4).map(
                    ({ title, href }, index) => {
                      return (
                        <div key={index}>
                          <Link href={href} className="text-sm">
                            {title}
                          </Link>
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
              <div className="text-xs space-y-2 md:w-[50%]">
                <h1 className="font-bold text-base">Contact</h1>
                <p className="leading-[20px]">
                  Plot 4, 5 Adeloye Oladejo street, Alagbaka, Akure 340001, Ondo
                  State, Nigeria.
                </p>
                <p>
                  <Link
                    href="mailto:hello@monietab.com"
                    className="hover:text-opacity-60 cursor-pointer hover:transition-all duration-200"
                  >
                    hello@monietab.com
                  </Link>
                </p>
                <p>+2347049397696</p>
              </div>
            </section>
          </div>
          <section className="flex justify-between py-6">
            <div className="md:space-y-4 space-y-2 text-xs md:w-[40%] w-full border-t-2 border-[#ffffff] border-opacity-30 pt-4">
              <p>
                <b>Monietab</b> is a product of <b>Mora Technologies Limited,</b> a duly registered company in Nigeria.
                By using this platform, you accept our <Link href="/terms">Terms of Use</Link> and <Link href="/privacy">Privacy Policy</Link>
              </p>
              {/* <p>
                The content on this website does not constitute a complete
                description of Monietab&apos;s offerings and services. By using
                this website, you accept our Terms of Use and Privacy Policy.
              </p> */}
              <p>Copyright ©2026 Monietab. All rights reserved</p>
            </div>
            <div className="md:space-y-4 space-y-2 md:w-[50%] hidden md:block">
              <h2 className="text-base font-bold">Resources</h2>
              <div>
                <Link href="/" className="text-sm">
                  Calculator
                </Link>
                {LANDING_NAV_ITEMS.slice(2, 4).map(({ title, href }, index) => {
                  return (
                    <div key={index}>
                      <Link href={href} className="text-sm">
                        {title}
                      </Link>
                    </div>
                  );
                })}
              </div>
            </div>
          </section>
        </div>
      </main>
      <div className="bg-secondary pt-6">
        <Image src={monietab} alt="Monietab" />
      </div>
    </div>
  );
};

export default Footer;
